import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { api } from '../../../Services/API'

import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  SendPolicyDocumentsByEmailClientRequest,
  SendPolicyDocumentsByEmailClientResponse,
} from '../../../@types/SendPolicyDocumentsByEmail'
import { useSendPolicyDocumentsByEmailStore } from '../../../Stores/useSendPolicyDocumentsByEmailStore'
import { useWarningStore } from '../../../Stores/warningStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { WARNING_BAR } from '../../../constants/warningBar'
import { t } from '../../../i18n'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: SendPolicyDocumentsByEmailClientRequest) => {
  const response = await api.post<SendPolicyDocumentsByEmailClientResponse>(
    API_ROUTES.sendPolicyDocumentsByEmail,
    payload,
  )

  return response.data
}

export const useSendPolicyDocumentsByEmail = () => {
  const { handleErrorRequest } = useErrorRequest()
  const { setSendPolicyDocumentsByEmail } = useSendPolicyDocumentsByEmailStore()
  const { setWarningOptions } = useWarningStore()

  return useMutation({
    mutationFn: (payload: SendPolicyDocumentsByEmailClientRequest) =>
      request(payload!),
    onSuccess(data) {
      setSendPolicyDocumentsByEmail(data)
      setWarningOptions({
        type: WARNING_BAR.type.success,
        labelTypes: [t('general.success.emailSent')],
        mode: WARNING_BAR.mode.show,
      })
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
